import { useCurrentBreakpoint } from "@ui/hooks/useCurrentBreakpoint";

import { Button } from "@jti/core-components/components/Button";

import { useFormState } from "../../../../components/Form";
import { useSavBlocking } from "../../SavBlockingContext";

import styles from "./BirthDateFormCtas.module.scss";

export interface BirthDateFormCtasProps {
  confirmLabel: string;
  leaveLabel: string;
  leaveUrl: string;
  onLeaveClick?: () => void;
}

export const BirthDateFormCtas = ({ confirmLabel, leaveLabel, leaveUrl, onLeaveClick }: BirthDateFormCtasProps) => {
  const { errors, isValid } = useFormState();
  const { isBlockingEnabled, isBlocked } = useSavBlocking();
  const { mainBreakpoint } = useCurrentBreakpoint();
  const buttonSize = ["xs", "sm"].includes(mainBreakpoint) ? "sm" : "md";

  const hasFieldErrors = Object.values(errors).length > 0;
  // When blocking, an underage user must be able to submit to trigger the block,
  // so only require a valid form; otherwise also guard on the manual minimumAge error.
  const isConfirmDisabled = isBlockingEnabled ? !isValid : !isValid || hasFieldErrors;

  return (
    <div className={styles.actionWrapper}>
      {!isBlocked && (
        <Button
          className={styles.ageConfirmationButton}
          disabled={isConfirmDisabled}
          type="submit"
          variant="primary"
          size={buttonSize}
          data-testid="confirm-button"
        >
          {confirmLabel}
        </Button>
      )}
      <Button
        href={leaveUrl}
        className={styles.ageConfirmationButton}
        variant="secondary"
        data-testid="leave-button"
        size={buttonSize}
        onClick={onLeaveClick}
      >
        {leaveLabel}
      </Button>
    </div>
  );
};
